import { apiInstance } from "./api"

const endpoint = "/specification"

export const getAllFoodSpecifications = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}